import axios from "@/libs/api.request";
export function getDataInfo(params) {
    return axios.request({
        url: "WebAboutUs/getDataList",
        method: "get",
        params:params,
    })
}

export function submitDataInfo(params) {
    return axios.request({
        url: "WebAboutUs/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

export function getRecruitData(params){
    return axios.request({
        url: "WebAboutRecruit/getRecruitList",
        method: "get",
        params:params,
    })
}
export function submitRecruitInfo(params) {
    return axios.request({
        url: "WebAboutRecruit/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}